/**
 * SW-1 — which property, if any, a URL is showing.
 *
 * Lives here rather than inside `PropertySwitcher` for two reasons. It has no
 * React in it, and every test suite in this repo tests modules like this one
 * directly — importing a component that pulls in `react-router-dom` fails to
 * resolve under the jest config, which is why the 58 existing suites are all
 * shaped this way.
 */

/**
 * @param {string} pathname
 * @returns {number|null} the property id, or null when the URL is not a
 *   property page. `/properties` (the list) and `/properties/bulk-import`
 *   (a real route) are both null — a looser pattern would return
 *   "bulk-import" and the switcher would name a property that does not exist.
 */
export function propertyIdFromPath(pathname) {
  const m = /^\/properties\/(\d+)(?:\/|$)/.exec(pathname || '');
  return m ? Number(m[1]) : null;
}
